import React from 'react';

/**
 * Multiple-choice question renderer (checkboxes).
 * Shows "Choose N" instruction.
 */
export default function MultiChoice({ question, answer = [], onChange, disabled = false }) {
  const selectedSet = new Set(answer);
  const required = question.required_selections || 2;

  const handleToggle = (optionId) => {
    if (disabled) return;
    const newSet = new Set(selectedSet);
    if (newSet.has(optionId)) {
      newSet.delete(optionId);
    } else {
      newSet.add(optionId);
    }
    onChange(Array.from(newSet));
  };

  return (
    <div>
      <p className="text-sm text-gray-500 mb-3 font-medium">
        Choose {required} answers
      </p>
      <div className="space-y-2">
        {question.options.map(option => (
          <label
            key={option.id}
            className={`flex items-start gap-3 p-4 rounded-lg border-2 cursor-pointer transition-all ${
              disabled ? 'cursor-default' : 'hover:bg-gray-50'
            } ${
              selectedSet.has(option.id)
                ? 'border-blue-500 bg-blue-50'
                : 'border-gray-200 bg-white'
            }`}
          >
            <input
              type="checkbox"
              checked={selectedSet.has(option.id)}
              onChange={() => handleToggle(option.id)}
              disabled={disabled}
              className="mt-1 shrink-0"
            />
            <div>
              <span className="font-medium text-gray-400 mr-2">{option.id}.</span>
              <span className="text-gray-900">{option.text}</span>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
}
